import { useMemo } from "react";

import {
  ProgressItemEnum,
  ProgressItemState,
} from "@app/analytics/GettingStarted/types";
import { isProgressItemCompleted } from "@app/analytics/GettingStarted/utils";
import useConnectedProviders from "@app/analytics/hooks/sso/useConnectedProviders";
import useFeatureAccess from "@app/common/hooks/useFeatureAccess";

const useGetCalendarState = (progress: number): ProgressItemState => {
  const { canConnectCalendars } = useFeatureAccess();

  const isCompleted = isProgressItemCompleted(
    progress,
    ProgressItemEnum.CALENDAR
  );

  const { hasConnectedCalendarProviders } = useConnectedProviders({
    enabled: !isCompleted,
  });

  const isUnmarkedComplete =
    canConnectCalendars && hasConnectedCalendarProviders && !isCompleted;

  const state = isUnmarkedComplete
    ? "unmarked_complete"
    : isCompleted
      ? "complete"
      : "todo";

  return useMemo(
    () => ({
      type: ProgressItemEnum.CALENDAR,
      state,
    }),
    [state]
  );
};

export default useGetCalendarState;
